
const Footer = () => {
    return ( 
        <>
            <footer className=" text-center text-light text-lg-start">
            <div className="text-center p-3 " style={{backgroundColor: 'rgba(0, 0, 0, 0.2)'}}>
                Created with <i className="far fa-heart red-text"></i>  by
                <a className=" links ml-3" target="_blank" rel="noopener noreferrer" href="https://github.com/Ydannel/">Yanet Batista</a>
            </div>
                
            </footer>
        </>
     );
}
 
export default Footer;
